import Loadable from "react-loadable";
import Loader from "components/shared/loader/loader";
import { IRoute } from "shared/interface/types";

const parentBreadCrumbs = [
  { title: "menu_sidebar_management" },
  { title: "menu_sidebar_management_list_management" },
  { title: "menu_sidebar_management_service" },
  { title: "menu_sidebar_management_service_cash_less_workshop" }
];
const CashLessWorkshopManagementListing = Loadable({
  loader: () => import("container/management/cashLessWorkshop"),
  loading() {
    return <Loader />;
  }
});

export const cashLessWorkshopRoutes: IRoute[] = [
  {
    path: "/management/cash-less-workshop",
    element: <CashLessWorkshopManagementListing />,
    handle: {
      crumbs: parentBreadCrumbs
    }
  }
];
